import React from 'react';
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  IconButton,
} from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GuardianImage from '../../assets/icon/Add_guardian.svg';
import '../views/dashboard/min_promise/MinPromise.css';
import { useAuth } from '../auth/Auth';
import {
  GUARDIAN_LOGIN_ROUTE,
  GUARDIAN_SETTINGS_ROUTE,
  MULTI_LOGIN,
} from '../../constants/routes.constants';
import { useHandleMultiLogin } from '../../utils/multilogin';

const ConnectCampModal = ({ showModal, setShowModal }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { logout, guardian, dependent } = useAuth();

  const onClose = () => {
    setShowModal(false);
  };
  const { handleSwithChildToGuardian } = useHandleMultiLogin();

  const handleClose = () => {
    if (guardian?.viewer === 'guardian' || dependent?.viewer === 'guardian') {
      handleSwithChildToGuardian(guardian?.id, MULTI_LOGIN, MULTI_LOGIN);
    } else {
      logout(GUARDIAN_LOGIN_ROUTE);
    }
  };

  return (
    <Dialog
      open={showModal}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: { borderRadius: '15px', padding: isMobile ? '8px' : '16px' },
      }}
    >
      <DialogContent>
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: isMobile ? 8 : 16,
            right: isMobile ? 8 : 16,
            color: '#321b6d',
          }}
        >
          <CloseIcon />
        </IconButton>

        <Grid container direction="column" alignItems="center">
          {/* Image */}
          <Grid item>
            <img
              src={GuardianImage}
              alt="Add Guardian"
              style={{
                width: isMobile ? '120px' : '200px',
                height: 'auto',
                marginBottom: '10px',
              }}
            />
          </Grid>

          {/* Title */}
          <Grid item style={{ marginTop: '20px', width: '100%' }}>
            <Typography
              variant="h3"
              align="center"
              fontSize={isMobile ? '24px' : '30px'}
              fontWeight="800"
              color="#321b6d"
              style={{ padding: isMobile ? '0 8px' : '0 16px' }}
            >
              Hey buddy, you are not part of any Camp right now.
            </Typography>
          </Grid>

          {/* Description */}
          <Grid item style={{ marginTop: '20px' }}>
            <Typography
              variant="body1"
              align="center"
              fontSize={isMobile ? '14px' : '18px'}
              fontWeight="700"
              color="#321b6d"
              style={{ padding: isMobile ? '0 8px' : '0 16px' }}
            >
              Please ask your Guardians to add a Camp code to continue.
            </Typography>
          </Grid>
        </Grid>

        {/* Button */}
        <Grid container direction="column" alignItems="center">
          <Grid item width="100%" sx={{ maxWidth: '392px !important' }}>
            <button
              className="Yes_btn"
              style={{
                marginTop: isMobile ? '16px' : '20px',
                fontSize: isMobile ? '14px' : '16px',
                width: '100%',
              }}
              onClick={handleClose}
            >
              Connect Camp
            </button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectCampModal;
